/**
 * Class: utilities
 * Description: Utilities functions
 */
import "./polyfills.js";
import Emitter from "./emitter";
import Vue from "vue";
import { createApp, ref } from "vue";
export const emitter = new Emitter();
// import ally from 'ally.js';

export const html = document.querySelectorAll("html");
export const body = document.querySelectorAll("body");
export const main = document.querySelectorAll("#main");

export let modules = [];
let self = this;

// short an sweet polyfill for ie11 forEach
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}
if (window.HTMLCollection && !HTMLCollection.prototype.forEach) {
	HTMLCollection.prototype.forEach = Array.prototype.forEach;
}

export function initComponent(moduleClass, config) {
	// init new modules and
	if (config && config.el) {
		if (typeof config.el === "string") {
			config.el = document.querySelectorAll(config.el);
		}
		if (typeof config.el == "object") {
			config.el.forEach(function (el, index) {
				// let localConfig = { ...config, ...{ el: el } };
				let localConfig = Object.assign({}, config, { el: el });
				if (localConfig.name) {
					if (index > 0) {
						console.warn(
							"Module init: more than one module with the selector exists in the dom, be aware that there will only be on in the modulelist"
						);
					}
					modules[localConfig.name] = new moduleClass(localConfig);
				} else {
					modules.push(new moduleClass(localConfig));
				}
			});
		}
	} else {
		console.warn(
			"Module init: Please check that the provided selector and module-class exists"
		);
	}
}
export function initVueApp(vueComponent, config) {
	// init new modules and
	if ((typeof config.el === "string" || "object") && vueComponent) {
		let elements;

		if (typeof config.el == "string") {
			elements = document.querySelectorAll(config.el);
		} else if (typeof config.el == "object") {
			elements = config.el;
		}
		elements.forEach((element) => {
			let vueData = vueComponent;
			var vueApp = createApp(vueData);
			vueApp.mount(element);
		});
	} else {
		console.warn(
			"Problem with init VueApp: Please check that the provided selector and vue-component exists",
			vueComponent,
			selector
		);
	}
}
export function debounce(func, wait, immediate) {
	var timeout;
	return function () {
		var context = this,
			args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) {
				func.apply(context, args);
			}
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait || 200);
		if (callNow) {
			func.apply(context, args);
		}
	};
}
export function isMobile() {
	return this.getSize() == "xsmall" || this.getSize() == "small";
}
// get size of window.
export function getSize() {
	return window
		.getComputedStyle(document.querySelector("body"), ":before")
		.getPropertyValue("content")
		.replace(/\"/g, "");
}

var lastSize = getSize();
window.addEventListener(
	"resize",
	debounce(function () {
		const size = getSize();
		emitter.emit("responsive/resize", size);
		if (size !== lastSize) {
			emitter.emit("responsive/sizechange", size);
			lastSize = size;
		}
	}, 50)
);
var prevScrollpos = window.pageYOffset;
window.addEventListener(
	"scroll",
	debounce(function () {
		var currentScrollPos = window.pageYOffset;
		var direction = "up";
		if (prevScrollpos - 5 > currentScrollPos) {
			// add some buffer so we dont get flickr
			direction = "up";
		} else if (prevScrollpos + 20 < currentScrollPos) {
			// add som buffer so the user can scroll slowly down the page without this triggering
			direction = "down";
		} else {
			direction = "";
		}
		prevScrollpos = currentScrollPos;
		emitter.emit("window/scroll", {
			top: window.pageYOffset,
			direction: direction,
		});
	}, 10)
);
export function setHashUrl(hash) {
	if (history.replaceState) {
		history.replaceState(null, null, "#" + hash);
	} else {
		location.hash = "#" + hash;
	}
}
export function setQueryStringParameter(name, value) {
	const params = new URLSearchParams(window.location.search);
	params.set(name, value);
	window.history.replaceState(
		{},
		"",
		decodeURIComponent(`${window.location.pathname}?${params}`)
	);
}
export function deleteQueryStringParameter(name) {
	const params = new URLSearchParams(window.location.search);
	params.delete(name);
	window.history.replaceState(
		{},
		"",
		decodeURIComponent(`${window.location.pathname}?${params}`)
	);
}
export function resetHashUrl() {
	if (history.replaceState) {
		history.replaceState(null, null, "./");
	} else {
		location.hash = "";
	}
}

// export function makeSlug(string) {
// 	var slug = false;
// 	if (string.length) {
// 		slug = string.replace(/ +/g, "_");
// 	}
// 	return slug;
// }
export function isDomElement(obj) {
	return obj instanceof Element || obj instanceof HTMLDocument;
}
export function setAriaProp(el, prop, value) {
	el.setAttribute("aria-" + prop, value);
	return el;
}

export function createCookie(name, value, days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + value + expires + "; path=/";
}

export function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == " ") c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

export function eraseCookie(name) {
	createCookie(name, "", -1);
}

export function focusWhitin() {
	var slice = [].slice;
	var removeClass = function (elem) {
		elem.classList.remove("js-focus-within");
	};
	var update = (function () {
		var running, last;
		var action = function () {
			var element = document.activeElement;
			running = false;
			if (last !== element) {
				last = element;
				slice
					.call(document.getElementsByClassName("js-focus-within"))
					.forEach(removeClass);
				while (element && element.classList) {
					element.classList.add("js-focus-within");
					element = element.parentNode;
				}
			}
		};
		return function () {
			if (!running) {
				requestAnimationFrame(action);
				running = true;
			}
		};
	})();
	document.addEventListener("focus", update, true);
	document.addEventListener("blur", update, true);
	update();
}

function testObjectfit() {
	if (
		"objectFit" in document.documentElement.style !== false &&
		!window.navigator.userAgent.indexOf("Edge/16.") !== -1
	) {
		return true;
	} else {
		return false;
	}
}

export function objectFitToParentBackground(el) {
	const source = el.getAttribute("src");
	el.parentElement.style.backgroundImage = "url(" + source + ")";
	el.parentElement.style.backgroundSize = "cover";
	el.parentElement.style.backgroundPosition = "center center";
	el.style.opacity = 0;
}
export const supportsObjectfit = testObjectfit("object-fit");

export function formatDate(date, monthAsText = false) {
	const tempDate = new Date(date);
	const lang = document.documentElement
		? document.documentElement.lang
		: "da";
	const monthsArray = lang == "da" ? monthsShort.da : monthsShort.en;
	const month = monthAsText
		? monthsArray[tempDate.getMonth()]
		: ("0" + (tempDate.getMonth() + 1)).slice(-2);
	const dateString =
		("0" + tempDate.getDate()).slice(-2) +
		"." +
		(monthAsText ? " " : "") +
		month +
		(monthAsText ? " " : ".") +
		tempDate.getFullYear();
	return dateString;
}

export function formatDateNoLeadingZeros(
	date,
	monthAsText = false,
	shortYear = false
) {
	const tempDate = new Date(date);
	const lang = document.documentElement
		? document.documentElement.lang
		: "da";
	const monthsArray = lang == "da" ? monthsShort.da : monthsShort.en;
	const month = monthAsText
		? monthsArray[tempDate.getMonth()]
		: parseInt(("0" + (tempDate.getMonth() + 1)).slice(-2));
	const dateString =
		parseInt(("0" + tempDate.getDate()).slice(-2)) +
		"." +
		(monthAsText ? " " : "") +
		month +
		(monthAsText ? " " : ".") +
		(shortYear
			? tempDate.getFullYear().toString().slice(2, 4)
			: tempDate.getFullYear());
	return dateString;
}
export function formatDateTime(date, at = "", hideMinutes = false) {
	if (date == "" || !date) {
		return "";
	}
	const tempDate = new Date(date);
	const dateString =
		("0" + tempDate.getDate()).slice(-2) +
		"." +
		("0" + (tempDate.getMonth() + 1)).slice(-2) +
		"." +
		tempDate.getFullYear() +
		" " +
		(at != "" ? at + " " : "") +
		("0" + tempDate.getHours()).slice(-2) +
		(!hideMinutes ? ":" + ("0" + tempDate.getMinutes()).slice(-2) : "");

	return dateString;
}

export function formatDateTimeNoLeadingZeros(
	date,
	at = "",
	hideMinutes = false,
	shortYear = false
) {
	if (date == "" || !date) {
		return "";
	}
	const tempDate = new Date(date);
	const dateString =
		parseInt(("0" + tempDate.getDate()).slice(-2)) +
		"." +
		parseInt(("0" + (tempDate.getMonth() + 1)).slice(-2)) +
		"." +
		(shortYear
			? tempDate.getFullYear().toString().slice(2, 4)
			: tempDate.getFullYear()) +
		" " +
		(at != "" ? at + " " : "") +
		parseInt(("0" + tempDate.getHours()).slice(-2)) +
		(!hideMinutes ? ":" + ("0" + tempDate.getMinutes()).slice(-2) : "");

	return dateString;
}

export function isDateValid(date) {
	var expression = new RegExp(/^\d{2}\.\d{2}\.\d{4}$/); // format dd.mm.yyyy
	const formatIsValid = expression.test(date);
	var splitDate = date.split(".");
	var dateString =
		splitDate[2] +
		"-" +
		String(parseInt(splitDate[1])) +
		"-" +
		parseInt(splitDate[0]);

	if (formatIsValid) {
		// is format correct
		return true;
	} else {
		return false;
	}
}

export function isElementInViewport(el) {
	var rect = el.getBoundingClientRect();

	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <=
			(window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <=
			(window.innerWidth || document.documentElement.clientWidth)
	);
}

export function slideElementInViewport(el) {
	var rect = el.getBoundingClientRect();

	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.right <=
			(window.innerWidth || document.documentElement.clientWidth)
	);
}

export let dataStorage = {
	_storage: new WeakMap(),
	put: function (element, key, obj) {
		if (!this._storage.has(element)) {
			this._storage.set(element, new Map());
		}
		this._storage.get(element).set(key, obj);
	},
	get: function (element, key) {
		return this._storage.get(element).get(key);
	},
	has: function (element, key) {
		return (
			this._storage.has(element) && this._storage.get(element).has(key)
		);
	},
	remove: function (element, key) {
		var ret = this._storage.get(element).delete(key);
		if (!this._storage.get(element).size === 0) {
			this._storage.delete(element);
		}
		return ret;
	},
};

export const keys = {
	enter: 13,
	backspace: 8,
	tab: 9,
	escape: 27,
	pageup: 33,
	pagedown: 34,
	end: 35,
	home: 36,
	leftarrow: 37,
	uparrow: 38,
	rightarrow: 39,
	downarrow: 40,
};
export const monthsShort = {
	da: [
		"jan.",
		"feb.",
		"mar.",
		"apr.",
		"maj",
		"jun.",
		"jul.",
		"aug.",
		"sep.",
		"okt.",
		"nov.",
		"dec.",
	],
	en: [
		"jan.",
		"feb.",
		"mar.",
		"apr.",
		"may",
		"jun.",
		"jul.",
		"aug.",
		"sep.",
		"oct.",
		"nov.",
		"dec.",
	],
};

export function getMonday(d) {
	var today = d;
	if (today.getDay() == 1) return today; // already on monday
	let monday;
	// On a sunday
	if (today.getDay() == 0) {
		monday = new Date(today.setDate(today.getDate() - 6));
	} else {
		monday = new Date(today.setDate(today.getDate() - today.getDay() + 1));
	}
	return monday;
}

export function getThisWeek(d) {
	const monday = this.getMonday(d);

	const sunday = new Date(monday);
	sunday.setDate(sunday.getDate() + 6);
	return { monday, sunday };
}

export function getWeek(d) {
	var date = new Date(d);
	date.setHours(0, 0, 0, 0);
	// Thursday in current week decides the year.
	date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
	// January 4 is always in week 1.
	var week1 = new Date(date.getFullYear(), 0, 4);
	// Adjust to Thursday in week 1 and count number of weeks from date to week1.
	return (
		1 +
		Math.round(
			((date.getTime() - week1.getTime()) / 86400000 -
				3 +
				((week1.getDay() + 6) % 7)) /
				7
		)
	);
}

export function formatDateToSlash(datestring) {
	const formattedDate = datestring
		? datestring.replace(/(\d{2})\.(\d{2})\.(\d{4})/, "$3-$2-$1")
		: datestring;
	return formattedDate;
}
